import React from 'react';

import { Modal } from 'antd';

import { BASE_URL } from 'constants/Common';

import './popup.less';

const PopupBanner = (props) => {
  const { visible, onClose, bannerList } = props;

  return (
    <Modal visible={visible} onCancel={onClose} footer={null} className="commonModalBanner fixSize popupBanner">
      <div className="bannerpopupImg">
        {/* */}
        {/* <Slider {...SLIDER_SETTINGS}> */}
        {bannerList?.map?.((path) => (
          <div key={path} className="popupImageSlider">
            {['mp4', 'mkv', 'wmv'].includes(path.split('.').pop().toLowerCase()) ? (
              <div className="topbannerImage">
                <video autoPlay loop muted playsInline>
                  <source src={`${BASE_URL}${path}`}></source>
                </video>
              </div>
            ) : (
              <div className="topbannerImage">
                <img src={`${BASE_URL}${path}`} alt="banner" />
              </div>
            )}
          </div>
        )) ?? null}
        {/* </Slider> */}
      </div>
    </Modal>
  );
};
export default PopupBanner;
